import api from './api';

const CompetenceService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/competences/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching competences:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/competences/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching competence:', error);
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/competences/', data);
      return response.data;
    } catch (error) {
      console.error('Error creating competence:', error);
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/competences/${id}/`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating competence:', error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/competences/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting competence:', error);
      throw error;
    }
  }
};

export default CompetenceService;
